import React, { useState } from 'react';
import MapComponent from '../components/MapComponent';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Delivery = () => {
  const [start, setStart] = useState({ lat: 1.3521, lng: 103.88 }); // Default start point
  const [end, setEnd] = useState({ lat: 1.3521, lng: 103.881 }); // Default end point
  const [routeData, setRouteData] = useState(null);

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const startCoords = `${start.lng},${start.lat}`;
    const endCoords = `${end.lng},${end.lat}`;
    const url = `http://localhost:6000/route/v1/driving/${startCoords};${endCoords}?overview=full&geometries=polyline&steps=true&generate_hints=false`;
    const response = await axios.get(url);
    setRouteData(response.data);
  } catch (error) {
    console.error(error);
  }
};


  return (
    <div>
      <h1 className="card-title">You are ahead of your time</h1>
      <p className="card-text">This feature is currently being built with the discretion and expertise of a pool of trusted deliverypersons you will be introduced to.<br />Check back again later!<br /><img src="./rickshaw.png" alt="Deliveryperson" style={{ height: '200px' }} /></p>
      <Link to="/home">Go back to Home</Link>
      
      <h1>Route Finder</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            Start Point (lat, lng):
            <input
              type="text"
              value={`${start.lat}, ${start.lng}`}
              onChange={(e) => {
                const [lat, lng] = e.target.value.split(',').map(Number);
                setStart({ lat, lng });
              }}
            />
          </label>
        </div>
        <div>
          <label>
            End Point (lat, lng):
            <input
              type="text"
              value={`${end.lat}, ${end.lng}`}
              onChange={(e) => {
                const [lat, lng] = e.target.value.split(',').map(Number);
                setEnd({ lat, lng });
              }}
            />
          </label>
        </div>
        <button type="submit">Submit</button>
      </form>
      <MapComponent start={start} end={end} routeData={routeData} />
    </div>
  );
};

export default Delivery;
